// extracted by mini-css-extract-plugin
module.exports = {"movieReview":"ehlgc","content":"a92G5","flexbox":"tgYx0","rating":"B4DNg"};